import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  // Vite's replacement for webpack's require.context: bulk-import every locale
  // JSON eagerly, keyed by path (e.g. './locales/en.json').
  const locales = import.meta.glob('./locales/*.json', { eager: true, import: 'default' })
  const messages = {}
  Object.keys(locales).forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\.json$/i)
    if (matched && matched.length > 1) {
      messages[matched[1]] = locales[key]
    }
  })
  return messages
}

// Legacy/ISO locale codes that don't match our locale file names. Chinese is
// keyed as 'cn' across the app (cn.json, the language switcher, flag lookup),
// but browsers/older builds may have stored the ISO code 'zh' in localStorage.
const LOCALE_ALIASES = {
  zh: 'cn',
  'zh-cn': 'cn',
  'zh-hans': 'cn'
}

function resolveLocale (messages) {
  const stored = (localStorage.getItem('lang') || '').toLowerCase()
  const normalized = LOCALE_ALIASES[stored] || stored
  // Fall back to 'en' for anything we don't actually have messages for, so we
  // never end up on a locale with zero translations (which breaks every key).
  return messages[normalized] ? normalized : 'en'
}

const messages = loadLocaleMessages()

export default new VueI18n({
  locale: resolveLocale(messages),
  fallbackLocale: 'en',
  messages
})
